/**
 * Секунды от нажатия в ленте до «остался один клик».
 *
 * Это главное число приёмки, и до сих пор его не мерил никто. В журнале попыток
 * лежит время до подтверждения человеком — в него входит его собственная
 * нерешительность: перечитать кэф, прикинуть лимит, отойти. Ускоряем мы не это.
 * Наш отрезок кончается там, где сделано всё, что могли сделать мы: матч
 * найден, ячейка обведена, сумма стоит в поле.
 *
 * Момент знает только расширение, а сеть ему не положена — значит, число едет
 * той же дорогой, что и отчёты о промахах: расширение копит, лента увозит.
 * Задержка в минуты тут ничего не стоит: вопрос приёмки задают не в реальном
 * времени.
 */

export const SECS = 'forq:secs';

export interface ReadySec {
  venue: string;
  /** Миллисекунды от метки обещания ленты до готового купона. */
  ms: number;
  /** `ok` — в поле наша сумма; `changed` — контора поставила свою. */
  filled: 'ok' | 'changed';
}

/** Сколько держим. Больше не нужно: это медиана, а не история. */
export const KEEP = 50;

/**
 * Дольше этого число ничего не измеряет: человек ушёл и вернулся, а мы записали
 * бы его обед в свою медиану.
 */
export const MAX_MS = 10 * 60 * 1000;

export function parseSec(data: unknown): ReadySec | null {
  if (typeof data !== 'object' || data === null) return null;
  const one = data as Record<string, unknown>;
  if (typeof one.venue !== 'string' || one.venue === '') return null;
  if (typeof one.ms !== 'number' || !(one.ms > 0) || one.ms > MAX_MS) return null;
  if (one.filled !== 'ok' && one.filled !== 'changed') return null;
  return { venue: one.venue, ms: Math.round(one.ms), filled: one.filled };
}

export function parseSecs(data: unknown): ReadySec[] {
  if (typeof data !== 'object' || data === null) return [];
  const body = data as Record<string, unknown>;
  if (body.channel !== SECS || !Array.isArray(body.secs)) return [];
  const out: ReadySec[] = [];
  for (const raw of body.secs.slice(0, KEEP)) {
    const one = parseSec(raw);
    if (one !== null) out.push(one);
  }
  return out;
}

export const secsEnvelope = (secs: ReadySec[]): { channel: string; secs: ReadySec[] } => ({
  channel: SECS,
  secs,
});

/** Отправить накопленное. Молча: замер — наш инструмент, а не работа человека. */
export function report(secs: readonly ReadySec[], send: (body: ReadySec) => Promise<unknown>): void {
  for (const one of secs.slice(0, KEEP)) {
    void Promise.resolve(send(one)).catch(() => {
      // Не доехало — не беда: медиана считается по многим, а не по этому одному.
    });
  }
}
